export default {
  SET_JOBS: function (state, payload) {
    state.jobs = payload;
  },
  SET_JOB_BY_ID: function (state, payload) {
    state.jodDetail = payload;
  }
}
